import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Secret from '@shell/detail/secret.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'projectsecret',
  props: {
    value: {}
  },
  setup(__props: any) {


const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Secret, {
    value: props.value
  }, null, 8, ["value"]))
}
}

})